import { useCallback, useContext, useEffect, useState } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { trainBook, trainBookCRS } from "../../api/trains";
import { initPayment } from "../../components/trains/TrainsBookingProcess/helpers";
import { CurrencyContext } from "../../umbilical_tools";
import { useGetTraQueryParams } from "../trains";
import {
  trainSearchResultsFailed,
  trainSearchResultsIdle,
} from "../../actions/search/trains_search";
import { actionFailed } from "../../components/trains/TrainsBookingProcess/Prebook";
import { useHistory } from "react-router-dom";

export function useTrainBookingProcess({ page_session_id, market_type }) {
  const [loading, setLoading] = useState(true);
  const [bookData, setBookData] = useState({});

  const { currency: settedCurrency } = useContext(CurrencyContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const { selectionData } = useGetTraQueryParams();

  const { api_key, name, source_entity } = useSelector(
    (state) => state.WebsiteMetadata.metadata
  );

  const onFailed = useCallback(() => {
    dispatch(trainSearchResultsIdle());
    dispatch(trainSearchResultsFailed());
  }, [dispatch]);

  async function onBook(payload) {
    const results = await trainBook({
      payload,
      onError: (errorMsg) => actionFailed({ history, onFailed, errorMsg }),
    });

    if (!results) return;
    setBookData(results);
  }

  useEffect(() => {
    if (_.isEmpty(bookData)) return;

    const leadTraveler = bookData.travelers.find((t) => t.leadTraveler);

    const customer_user_data = {
      customer_uid: leadTraveler.id,
      email: leadTraveler.emailAddress,
      first_name: leadTraveler.firstName,
      last_name: leadTraveler.lastName,
      // nationality
    };
    const payload = {
      booking_id: bookData.booking_id,
      api_uid: bookData.api_uid,
      customer_remarks: "test",
      website_meta: { api_key, name, market_type },
      customer_user_data,
      source_entity,
    };
    trainBookCRS(payload)
      .then(async (res) => {
        const paymentPayload = {
          amount: res.booking_result.payment_data.amount,
          currency: res.booking_result.payment_data.currency,
          settedCurrency,
          reference: res.booking_result.reference,
          page_session_id,
          customer_user_data,
          source_entity,
        };
        //TODO: Fix condition for B2B
        if (market_type === "B2B") {
          history.push(`/train/successful-booking/${page_session_id}`);
          return;
        }
        await initPayment({ payload: paymentPayload, selectionData, dispatch });
      })
      .catch(() => history.push(`/failed-booking/${page_session_id}`));
  }, [bookData]);

  return {
    loading,
    setLoading,
    onBook,
  };
}
